import { FadeContainer } from '~/components/ui/FadeContainer';
import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import adsHeadLogo from '../../assets/images/ads_head_logo.svg';
import { AdsStages } from '../../models/Ads';
import { setActiveAdsState, useLayoutDispatch } from '../../redux';
import { AppAdsItem } from '../AppAdsItem';
import {
	StyledContainer,
	StyledCreateButton,
	StyledEmptyList,
	StyledHead,
	StyledList,
	StyledScrollContainerWrapper,
} from './AppAdsLive.styled';

const AppAdsLive = () => {
	const dispatch = useLayoutDispatch();
	const feedAds = useObservable(rage.ads.getFeedAds());

	return (
		<StyledContainer>
			<StyledHead>
				<img src={adsHeadLogo} />
				<Text
					style={{
						fontSize: 18,
						fontWeight: 500,
						color: '#ffffff',
						textAlign: 'center',
					}}
				>
					Лента объявлений
				</Text>
				<StyledCreateButton
					onClick={() => dispatch(setActiveAdsState(AdsStages.CREATE))}
				/>
			</StyledHead>
			<StyledScrollContainerWrapper>
				<FadeContainer height={435}>
					<StyledList>
						{feedAds.length === 0 ? (
							<StyledEmptyList>
								<Text
									style={{
										fontSize: 14,
										color: 'rgba(255, 255, 255, 0.35)',
										textAlign: 'center',
										padding: '24px 16px',
									}}
								>
									Объявлений пока нет
								</Text>
							</StyledEmptyList>
						) : (
							feedAds.map((item) => <AppAdsItem key={item.id} item={item} />)
						)}
					</StyledList>
				</FadeContainer>
			</StyledScrollContainerWrapper>
		</StyledContainer>
	);
};

export { AppAdsLive };
